module.exports = __webpack_public_path__ + "img/VectorshareLink.159e40a8.svg";